module.exports = __webpack_public_path__ + "img/addIcon.c517da44.svg";